import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const Sel = ({ value, onChange, options, placeholder, testid, className = "" }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger data-testid={testid} className={`bg-white ${className}`}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const l = typeof o === "string" ? o : o.label;
        return (
          <SelectItem key={v} value={v} data-testid={`${testid}-opt-${String(v).toLowerCase().replace(/\s+/g, "-")}`} className="capitalize">
            {l}
          </SelectItem>
        );
      })}
    </SelectContent>
  </Select>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    {children}
  </label>
);
